import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthenticatedHttpService } from './authenticatedhttp.service';

import { ProductLineFavorites } from '../model/product-line.favorites';
import { ModelFavorites } from '../model/model-favorites';

import { LoadingSpinnerService } from "./loading-spinner.service";

@Injectable()
export class UserFavoritesService {
    private baseUrl: string;
    private _productLineFavorites: ProductLineFavorites[];
    private _modelFavorites: ModelFavorites[];

    constructor(
        private _http: AuthenticatedHttpService
    ) {
        this.baseUrl = _http.getBaseURLFromCookie();
    }

    getProductLineFavorites(userId, refresh = false): Observable<ProductLineFavorites[]> {
        if (this._productLineFavorites && !refresh) {
            return Observable.of(this._productLineFavorites)
        } else {
            return this._http.get(`${this.baseUrl}/api/users/${userId}/productLineFavorites`)
                .map(x => x.json())
                .do(response => {
                    this._productLineFavorites = response;
                })
                .catch(this._http.handleError);
        }
    }

    createProductLineFavorite(productLineFavorite: ProductLineFavorites): Observable<ProductLineFavorites> {
        return this._http.post(`${this.baseUrl}/api/productLineFavorites/`, JSON.stringify(productLineFavorite)).
            map(x => {
                this.getProductLineFavorites(productLineFavorite.UserId, true).subscribe(plfavorites => {
                    this._productLineFavorites = plfavorites;
                });
                return x.json();
            })
            .catch(this._http.handleError);
    }

    deleteProductLineFavorite(productLineId: number): Observable<boolean> {
        let plf = this._productLineFavorites.find(x => x.ProductLineId === productLineId);
        if (plf !== undefined) {
            return this._http.delete(`${this.baseUrl}/api/productLineFavorites/${plf.UserFavoriteId}`)
                .map(x => {
                    return x.json();
                })
                .catch(this._http.handleError);
        }
    }

    getModelFavorites(userId, refresh = false): Observable<ModelFavorites[]> {
        if (this._modelFavorites && !refresh) {
            return Observable.of(this._modelFavorites)
        } else {
            return this._http.get(`${this.baseUrl}/api/users/${userId}/modelFavorites`)
                .map(x => x.json())
                .do(response => {
                    this._modelFavorites = response;
                })
                .catch(this._http.handleError);
        }
    }

    createModelFavorite(modelFavorite: ModelFavorites): Observable<ModelFavorites> {
        return this._http.post(`${this.baseUrl}/api/modelFavorites/`, JSON.stringify(modelFavorite)).
            map(x => {
                this.getModelFavorites(modelFavorite.UserId, true).subscribe(modelfavorites => {
                    this._modelFavorites = modelfavorites;
                });
                return x.json();
            })
            .catch(this._http.handleError);
    }

    deleteModelFavorite(favoriteId: number): Observable<boolean> {
        return this._http.delete(`${this.baseUrl}/api/modelFavorites/${favoriteId}`)
            .map(x => {
                return x.json();
            })
            .catch(this._http.handleError);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/user-favorites.service.ts